import { render } from "./custom-footer.vue?vue&type=template&id=3e93ade8"
const script = {}

import exportComponent from "/builds/ads-base/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__